import { gql } from '@apollo/client'

export const POLICY_NUMBER_VALID_QUERY = gql`
  query PolicyNumberValid($insuranceId: ID!, $policyNumber: String!) {
    policyNumberValid(insuranceId: $insuranceId, policyNumber: $policyNumber)
  }
`
